import { ProjectsResponse, ProjectsOfClientActionPayload } from '../../types/redux/stores/projects.types';
import * as actionDefinitions from './actionDefinitions';

export const getProjectsRequest = (payload: any) => ({ type: actionDefinitions.GET_PROJECTS_REQUEST, payload });
export const getProjectsRequestFailure = (payload: any) => ({ type: actionDefinitions.GET_PROJECTS_REQUEST_FAILURE, payload });
export const getProjectsRequestSuccess = (payload: ProjectsResponse) => ({ type: actionDefinitions.GET_PROJECTS_REQUEST_SUCCESS, payload });

export const getProjectsOfClientRequest = (payload: ProjectsOfClientActionPayload) => ({
  type: actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST,
  payload,
});
export const getProjectsOfClientRequestFailure = (payload: any) => ({
  type: actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST_FAILURE,
  payload,
});
export const getProjectsOfClientRequestSuccess = (payload: ProjectsResponse) => ({
  type: actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST_SUCCESS,
  payload,
});
export const getProjectsOfClientStopLoading = (payload: { clientId: string | null | undefined }) => ({
  type: actionDefinitions.GET_PROJECTS_OF_CLIENT_STOP_LOADING,
  payload,
});
